module.exports = __webpack_public_path__ + "img/image_10.8650cb13.png";